import React from 'react';
import { HotkeysProvider } from 'react-hotkeys-hook';

export enum KeyContexts {
  GLOBAL = 'global'
}

const KeyShortcuts: React.FC<React.PropsWithChildren> = ({ children }) => (
  <HotkeysProvider initiallyActiveScopes={[KeyContexts.GLOBAL]}>
    {children}
  </HotkeysProvider>
);

export default KeyShortcuts;
